import { Base_Url } from "../../BaseURL/BaseUrl";
import {
  getApiWithAuthorization,
  postApiWithAuthorization,
} from "../ApiMethods/ApiMethod";

const UseresUrl = `${Base_Url}/User`;

export const GetUserList = async (params) => {
  const res = await postApiWithAuthorization(
    `${UseresUrl}/GetUserList`,
    params
  );
  return res;
};

export const AddUpdateUser = async (params) => {
  const res = await postApiWithAuthorization(
    `${UseresUrl}/AddUpdateUser?ModuleName=${params.ModuleName}`,
    params
  );
  return res;
};
export const GetUserModel = async (ModuleName, KeyID) => {
  const res = await getApiWithAuthorization(
    `${UseresUrl}/GetUserModel?ModuleName=${ModuleName}&UserKeyID=${KeyID}`
  );
  return res;
};

export const ChangeUserStatus = async (ModuleName, KeyID) => {
  const res = await getApiWithAuthorization(
    `${UseresUrl}/ChangeUserStatus?ModuleName=${ModuleName}&UserKeyID=${KeyID}`
  );
  return res;
};

export const DeleteUser = async (ModuleName, KeyID) => {
  const res = await getApiWithAuthorization(
    `${UseresUrl}/DeleteUser?ModuleName=${ModuleName}&UserKeyID=${KeyID}`
  );
  return res;
};

export const GetUserLookupList = async (KeyID, ParentRoleTypeID) => {
  // Build query params conditionally
  const url = `${UseresUrl}/GetUserLookupList?UserKeyID=${KeyID}${
    ParentRoleTypeID ? `&ParentRoleTypeID=${ParentRoleTypeID}` : ""
  }`;

  const res = await getApiWithAuthorization(url);
  return res;
};

export const GetUserLookupListAllocated = async (KeyID) => {
  const res = await getApiWithAuthorization(
    `${UseresUrl}/GetUserLookupList?UserKeyID=${KeyID}`
  );
  return res;
};

export const SetUserCheckIn = async (params) => {
  const res = await postApiWithAuthorization(
    `${UseresUrl}/SetUserCheckIn`,
    params
  );
  return res;
};

export const SetUserCheckOut = async (params) => {
  const res = await postApiWithAuthorization(
    `${UseresUrl}/SetUserCheckOut`,
    params
  );
  return res;
};

export const GetUserCheckInCheckOutStatus = async (UserKeyID) => {
  const res = await getApiWithAuthorization(
    `${UseresUrl}/GetUserCheckInCheckOutStatus?UserKeyID=${UserKeyID}`
  );
  return res;
};

export const GetAttendanceList = async (params) => {
  const res = await postApiWithAuthorization(
    `${UseresUrl}/GetAttendanceList`,
    params
  );
  return res;
};

export const GetDailyReportModel = async (params) => {
  const res = await postApiWithAuthorization(
    `${UseresUrl}/GetDailyReportModel`,
    params
  );
  return res;
};

export const UpdateUserProfile = async (params) => {
  const res = await postApiWithAuthorization(
    `${UseresUrl}/UpdateUserProfile`,
    params
  );
  return res;
};
export const GetUserProfileModel = async (KeyID) => {
  const res = await getApiWithAuthorization(
    `${UseresUrl}/GetUserProfileModel?UserKeyID=${KeyID}`
  );
  return res;
};

export const AddUpdateUserServiceMapping = async (params) => {
  const res = await postApiWithAuthorization(
    `${UseresUrl}/AddUpdateUserServiceMapping`,
    params
  );
  return res;
};

export const GetUserMappedServices = async (UserKeyID, KeyID) => {
  const res = await getApiWithAuthorization(
    `${UseresUrl}/GetUserMappedServices?UserKeyID=${UserKeyID}&UserKeyIDForUpdate=${KeyID}`
  );
  return res;
};

export const GetJuniorUserLookupList = async (KeyID) => {
  const res = await getApiWithAuthorization(
    `${UseresUrl}/GetJuniorUserLookupList?UserKeyID=${KeyID}`
  );
  return res;
};
